import { useState, Fragment, useEffect } from "react";
import { TagIcon, FunnelIcon } from "@heroicons/react/20/solid";
import { CategoryFull } from "../../../../Models";
import RankingFilters from "./RankingFilters";
import { NIL } from "uuid";
import { useNotification } from "../../../../context/NotificationContext";
import { useLocation } from "react-router-dom";
import TagManagementModal from "../../../Shared/Modals/TagManagementModal";
import { PopUp } from "../../../../Models";
import { getTags } from "../../../../api/tag.api";
import useApiToken from "../../../../hooks/useApiToken";


export interface Subtag {
  count: number;
  id: string;
  name: string;
  tagSubtagId: string;
}

export interface Tags {
  id: string;
  name: string;
  count: number;
  subtags: Subtag[];
}

interface Props {
  selectedColumns: string[];
  setSelectedColumns: (columns: string[]) => void;
  applyFilters: (filter: any) => void;
  setSelectedRoleType: any;
  rankTypes: { id: string; name: string }[];
  rankCategoryLabels: CategoryFull[];
  tab: string;
  fetchAndSetRankType: () => Promise<void>;
  handleFilterQuery: (filter: string) => void;
  getData: (obj: any) => void;  
}

const RankingSideBarBody = ({
  applyFilters,
  setSelectedRoleType,
  setSelectedColumns,
  rankTypes,
  rankCategoryLabels,
  tab,
  fetchAndSetRankType,
  handleFilterQuery,
  selectedColumns,
  getData
}: Props) => {
  const token = useApiToken();
  const [isTag, setIsTag] = useState<boolean>(false);
  const [isManagementModal, setIsManagementModal] = useState<boolean>(false);
  const [pendingNotification, setPendingNotification] = useState<PopUp | null>(null);
  const { success, error: notifyError, info } = useNotification();
  const [rankType, setRankType] = useState<string>(NIL);

  const handleSetShow = (show: boolean) => {
    if (show && pendingNotification) {
      if (pendingNotification.type === "success") {
        success(pendingNotification.title, pendingNotification.description);
      } else if (pendingNotification.type === "error") {
        notifyError(pendingNotification.title, pendingNotification.description);
      } else {
        info(pendingNotification.title, pendingNotification.description);
      }
      setPendingNotification(null);
    }
  };
  const [tags, setTags] = useState<Tags[]>([]);
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const type = queryParams.get("type");
    setRankType(type ?? NIL);
}, [location.search]);

  useEffect(() => {
      refreshTags();
  }, [rankType, tab, token]);

  const refreshTags = () => {
    if (!token) return;
    let tags: any[] = [];
    if(tab === "Companies"){
      getTags(rankType, true, "rankboard", token).then((t) => {
        if(t && t.length > 0){
          tags = t.map((crt:any) => ({
            id: crt.id,
            name: crt.name,
            count: crt.count,
            subtags: crt.subtags
          }));
        }
        setTags(tags);
      });
    }
    else{
      getTags(rankType, false, "rankboard", token).then((t) => {
        if(t && t.length > 0){
          tags = t.map((crt:any) => ({
            id: crt.id,
            name: crt.name,
            count: crt.count,
            subtags: crt.subtags
          }));
        }
        setTags(tags);
      });
    }
  }

  return (
    <>
      <div className="flex gap-3 items-center px-3 my-4 text-sm text-gray-500 dark:text-gray-300 border-b-2 border-gray-300">
        <div className= {`flex gap-1 items-center pr-2 pb-3 dark:text-gray-300 ${isManagementModal ? "" : "border-b-2 border-entntblue text-black dark:text-white"}`}>
          <FunnelIcon className="h-3 w-3"/>
          <button 
          onClick={() => {
            applyFilters([]);
            setIsTag(false);
          }}
          >
            <h3 className="font-semibold">Filters</h3>
          </button>
        </div>
        <div className={`flex gap-1 items-center pb-3 dark:text-gray-300 ${isManagementModal ? "border-b-2 border-entntblue text-black dark:text-white" : "" }`}>
          <TagIcon className="h-3 w-3"/>
          <button onClick={() => {
            // applyFilters([]);
            setIsManagementModal(true);
          }}>
            <h6 className="font-semibold">Tags</h6>
          </button>
        </div>
      </div>

     
      <RankingFilters
          applyFilters = {applyFilters}
          setSelectedRoleType={setSelectedRoleType}
          rankTypes={rankTypes}
          tab={tab}
          fetchAndSetRankType={fetchAndSetRankType}
          rankCategoryLabels={rankCategoryLabels}
          handleFilterQuery={handleFilterQuery}
          selectedColumns={selectedColumns}
          setSelectedColumns={setSelectedColumns}
          refreshTags={refreshTags}
          tags={tags}
          setShow={handleSetShow}
          getData={(obj) => getData(obj)}
          setNotificationPopUp={(popUp: PopUp) => setPendingNotification(popUp)}
      />

      <TagManagementModal
      isOpen={isManagementModal}
      onCancel={() => setIsManagementModal(false)}
      title="Tag Management"
      tab={tab}
      setNotificationPopUp={(popUp: PopUp) => setPendingNotification(popUp)}
      refreshTags={refreshTags}
      rankType={rankType}
      setShow={handleSetShow}
      getData={getData}
      view="rankboard"
      />
    </>
  );
};

export default RankingSideBarBody;
